import { ArticleTypeService } from './../../../article-types/article-type.service';
import { ArticleType } from './../../../article-types/article-type.model';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddCatalogDialogComponent } from '../add-catalog-dialog/add-catalog-dialog.component';

@Component({
    selector: 'app-add-article-type-selection',
    templateUrl: './add-article-type-selection.component.html',
    styleUrls: ['./add-article-type-selection.component.scss'],
    standalone: false
})
export class AddArticleTypeSelectionComponent implements OnInit {

  selected: ArticleType;

  constructor(
    public dialogRef: MatDialogRef<AddCatalogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public articleTypeService: ArticleTypeService
  ) {


    // ...



  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(this.selected);
  }

  selectArticleType(articleType: ArticleType) {
    this.selected = articleType;
  }

}
